import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-sitemap-audits-page',
  templateUrl: './sitemap-audits-page.component.html',
  styleUrls: ['./sitemap-audits-page.component.css'],
})
export class SitemapAuditsPageComponent implements OnInit {
  latestAudit: any = null;
  dashboardData: any = null;
  history: any[] = [];
  missingUrls: any[] = [];
  loading = true;
  url = 'seoSitemapAudits';
  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/observability/seo/metricsDaily',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/observability/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/observability/social',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'MEDIAROOM',
      route: '/observability/mediaroom',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'LOGISTICS',
      route: '/observability/logistics',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-receipt',
      bgClass: 'bg-white',
      desc: 'ACCOUNTING',
      route: '/observability/accounting',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-coins',
      bgClass: 'bg-white',
      desc: 'FINANCE',
      route: '/observability/finance',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'HR',
      route: '/observability/hr',
    },
  ];

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.loadAll();
  }

  loadAll() {
    this.loading = true;
    this.loadDashboard();
    this.loadLatest();
    this.loadHistory();
    this.loadMissingUrls();
  }

  loadDashboard() {
    this.dataService.getData(`${this.url}/dashboard`).subscribe((res) => {
      if (res.rst) {
        this.dashboardData = res.data;
      }
    });
  }

  loadLatest() {
    this.dataService.getData(`${this.url}/latest`).subscribe((res) => {
      if (res.rst) {
        this.latestAudit = res.data;
      }
    });
  }

  loadHistory() {
    this.dataService.getData(`${this.url}/history`).subscribe((res) => {
      if (res.rst) {
        this.history = res.data;
      }
    });
  }

  loadMissingUrls() {
    this.dataService
      .getData(`${this.url}/latest/missing-urls`)
      .subscribe((res) => {
        if (res.rst) {
          this.missingUrls = res.data;
        }
        this.loading = false;
      });
  }

  runAudit() {
    this.dataService.postData(`${this.url}/run`, {}).subscribe((res) => {
      if (res.rst) {
        // Refresh after a delay or show message
        setTimeout(() => this.loadAll(), 2000);
      }
    });
  }

  onAuditSelected(audit: any) {
    this.latestAudit = audit;
    this.missingUrls = audit.missingUrls || [];
  }
}
